import { fetchAuthSession } from "aws-amplify/auth";
import { post } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { CARENOTES_DIRECT_QUERY_KEY } from "./useCareNotesDirectQuery";

export const useCareNotesDirectPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "carenotesapi",
        path: "/direct",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CARENOTES_DIRECT_QUERY_KEY] });
    },
  });
};
